import * as React from 'react';
import { observer, inject } from 'mobx-react';
import './pageSummaryPane.module.scss';
import { Page, Pane, PaneBody, PaneBackButton, ContextAwarePaneHeader } from '../../atoms/applications/page';
import { Loader } from '../../atoms/forms/loader';
import { ButtonWrapper, SubmitButton } from '../../atoms/forms/vertical/base';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { CouponInputForm } from '../coupons/CouponInputForm';
import { AppliedCouponSummary } from '../coupons/AppliedCouponSummary';
import { EntranceFeeSummary } from '../../atoms/applications/EntranceFeeSummary';
import { MembershipItemSummary } from '../../atoms/applications/MembershipItemSummary';
import { BaseApplicationPageState } from '../../../containers/application/states/BaseApplicationPageState';

type Props = {
    applicationState: BaseApplicationPageState;
};

@inject('applicationState')
@observer
export class ApplicationPageSummaryPane extends React.Component<Props> {
    render() {
        const {
            applicationPageResource,
            applicationPage,
            name,
            canGoBack,
            couponState,
            submitting,
            validateCouponCode,
            clearCoupons,
            entranceFeeItemName,
            validateFeeSummaryAndNext,
        } = this.props.applicationState;
        if (applicationPageResource.loading) {
            return <Loader />;
        }
        if (applicationPageResource.isNotFound()) {
            GlobalStatesV3.routing.replace('');
            return <div />;
        }
        return (
            <Page>
                <Pane>
                    {canGoBack && <PaneBackButton />}
                    <ContextAwarePaneHeader planName={name}>お申し込みプランの確認</ContextAwarePaneHeader>
                    <PaneBody>
                        {!couponState.appliedCoupon && (
                            <CouponInputForm
                                couponCodeField={couponState.couponCodeField}
                                onSubmit={validateCouponCode}
                                submitting={submitting}
                            />
                        )}
                        {couponState.appliedCoupon && (
                            <AppliedCouponSummary
                                code={couponState.appliedCoupon.code}
                                name={couponState.appliedCoupon.name}
                                description={couponState.appliedCoupon.description}
                                onRequestDelete={clearCoupons}
                            />
                        )}

                        {applicationPage.membership_item.price > 0 && (
                            <MembershipItemSummary item={applicationPage.membership_item} />
                        )}

                        <EntranceFeeSummary
                            name={entranceFeeItemName}
                            price={applicationPage.entrance_fee_item ? applicationPage.entrance_fee_item.price : 0}
                            priceWithTax={
                                applicationPage.entrance_fee_item ? applicationPage.entrance_fee_item.price_with_tax : 0
                            }
                            discount={
                                applicationPage.entrance_fee_item ? applicationPage.entrance_fee_item.discount : 0
                            }
                            showPlusIcon={applicationPage.membership_item.price > 0}
                            showHeader={applicationPage.membership_item.price == 0}
                        />
                        <div styleName="disclaimer">
                            {applicationPage.renewable &&
                                '※ お申込日を起算日とし、自動更新されます。12ヶ月後(12ヶ月プラン) / 6ヶ月後(6ヶ月プラン) / 1ヶ月後(1ヶ月プラン) 各プラン自動更新されます。'}
                        </div>
                        <ButtonWrapper>
                            <SubmitButton id="plan-select-submit" loading={false} onClick={validateFeeSummaryAndNext}>
                                お支払い情報の入力へ
                            </SubmitButton>
                        </ButtonWrapper>
                    </PaneBody>
                </Pane>
            </Page>
        );
    }
}
